import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'

import { SeFeCardModule } from 'se-fe-card'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeIconModule, seFeIconMoreVerticle } from 'se-fe-icon'
import { SeFeMenuModule } from 'se-fe-menu'
import { SeMySportsengineUiNginIframeModule } from '@se-po/se-my-sportsengine-ui-ngin-iframe'

import { PipesModule } from '../pipes/pipes.module'

import { NavBarComponent } from './nav-bar/nav-bar.component'
import { PaginationComponent } from './pagination/pagination.component'
import { PaymentPlanComponent } from './payment-plan/payment-plan.component'
import { SortColumnComponent } from './sort-column/sort-column.component'
import { SpinnerComponent } from './spinner/spinner.component'
import { DateStampComponent } from './date-stamp/date-stamp.component'
import { SeFeAvatarModule } from 'se-fe-avatar'
import { OAuthCallbackComponent } from './oauth-callback/oauth-callback.component'
import { SeFeSpinnerModule } from 'se-fe-spinner'
@NgModule({
  declarations: [
    DateStampComponent,
    NavBarComponent,
    OAuthCallbackComponent,
    PaginationComponent,
    PaymentPlanComponent,
    SortColumnComponent,
    SpinnerComponent
  ],
  imports: [
    CommonModule,
    PipesModule,
    SeFeAvatarModule,
    SeFeCardModule,
    SeFeButtonModule,
    SeFeIconModule,
    SeFeIconModule.include([
      seFeIconMoreVerticle
    ]),
    SeFeMenuModule,
    SeFeSpinnerModule,
    SeMySportsengineUiNginIframeModule,
    TranslateModule
  ],
  exports: [
    DateStampComponent,
    NavBarComponent,
    OAuthCallbackComponent,
    PaginationComponent,
    PaymentPlanComponent,
    SortColumnComponent,
    SpinnerComponent,
    SeMySportsengineUiNginIframeModule
  ],
})
export class ComponentsModule { }
